import basicMixin from '../../assets/mixins/basic';

export default {
  mixins: [basicMixin],
};
